import { PricingDetails } from "@db-models/pricing-db.model";
import { V2_PRICING_JSON } from "@constants/v2/plans.constants";

// Single source of pricing data — v2 plans (Basic / Starter / Team / Enterprise).
// Legacy plan versioning was retired after v2 launch; embedders no longer pass
// `plans-version`. Sales-mode 2y/3y intervals were removed at the same time.
export function resolvePricingList(): PricingDetails[] {
  return V2_PRICING_JSON;
}
